import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

import { SldMode } from '../../enclosure/models/sld.model';
import { IPlacedDevice } from '../../enclosure/models/grid.model';

@Directive({
    selector: '[appDisableMultipleClickForSldStartingPoint]',
    standalone: false
})
export class DisableMultipleClickForSldStartingPointDirective {

  @Input() mode: SldMode;
  @Input() placedDevice: IPlacedDevice;
  @Input() isSldMode: boolean;
  @Input() disableDuration: number;

  constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer: Renderer2
  ) {
  }

  @HostListener('click', ['$event'])
  click(_: MouseEvent) {
    if(this.isSldMode && this.mode === SldMode.CHOOSING_STARTING_POINT) {
      this.disableClick();
    }
  }

  disableClick() {
    this.renderer.addClass(this.elementRef.nativeElement, 'pointer-events-none');
    setTimeout(() => {
      this.renderer.removeClass(this.elementRef.nativeElement, 'pointer-events-none');
    }, this.disableDuration || 1000);
  }
}
